module.exports = __webpack_public_path__ + "img/exclamation-circle-solid.0f2ebc44.svg";